// lib

import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

// styles
import style from '@aytm/app/stats/page/question-views/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const VIEW_MODE_OPTIONS = [
  { text: 'Windmap', value: 'windmap', listText: 'Windmap' },
  { text: 'Timeslice', value: 'timeslice', listText: 'Timeslice' },
  { text: 'Aggregated', value: 'aggregated', listText: 'Aggregated' }
]
const LINE_MODE_OPTIONS = [
  { text: 'Precise', value: 'precise', listText: 'Precise' },
  { text: 'Smooth', value: 'smooth', listText: 'Smooth' },
  { text: 'Segmented', value: 'segmented', listText: 'Segmented' }
]

const Controls = ({ model, disabled, onModelChange }) => {
  const { batches, viewMode, lineMode } = model

  const onViewModeChange = event => {
    onModelChange({
      viewMode: event.value
    })
  }
  const onLineModeChange = event => {
    onModelChange({
      lineMode: event.value
    })
  }

  return (
    <div className={`${style.component} ${NO_PRINT}`}>
      <div className="p-fluid p-col-3">
        <Dropdown
          data-testid="stat-question-view-mode"
          className="p-dropdown-rounded"
          aria-label="View mode"
          ariaLabel="View mode"
          value={viewMode}
          options={
            1 == batches.length ? VIEW_MODE_OPTIONS.filter(item => 'aggregated' != item.value) : VIEW_MODE_OPTIONS
          }
          optionValue="value"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          disabled={disabled}
          onChange={disabled ? null : onViewModeChange}
        />
      </div>
      <div className="p-fluid p-col-3">
        <Dropdown
          data-testid="stat-question-line-mode"
          className="p-dropdown-rounded"
          aria-label="Line mode"
          ariaLabel="Line mode"
          value={lineMode}
          options={LINE_MODE_OPTIONS}
          optionValue="value"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          disabled={disabled}
          onChange={disabled ? null : onLineModeChange}
        />
      </div>
    </div>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onModelChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
